angular.module('picmonicng').directive('infiniteScrollPaginate', [
  '$filter',
  '$window',
  function ($filter, $window) {
    return {
      restrict: 'A',
      scope: {
        onNext: '&',
        triggerAt: '=',
        loading: '=',
      },
      link: function (scope, element, attrs) {
        var timeout;
        var trigger = scope.triggerAt ? scope.triggerAt : 0.9;
        element.bind('scroll', function (event) {
          var position = Math.max(element.scrollTop(), 0) / (element[0].scrollHeight - element.height());
          scope.$apply(function () {
            scope.scrolling = true;
            scope.position = position;
          });

          clearTimeout(timeout);
          timeout = setTimeout(function () {
            scope.$apply(function () {
              scope.scrolling = false;
            });
          }, 150);

          if (position >= trigger && typeof scope.onNext != 'undefined') {
            scope.onNext();
          }
        });
      },
    };
  },
]);
